import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Row, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";

//i18n
import { withNamespaces } from "react-i18next";
import { connect } from 'react-redux';

class Breadcrumbs extends Component {
     constructor(props) {
    super(props);
   
  }

  
  
    render() {

        const itemsLength = this.props.breadcrumbItems.length;

        return (
            <React.Fragment>
                {/* check charger details page in horizontal view */}
                        <Row>
                            <Col xs={12}>
                                <div className={`page-title-box  ${this.props.layoutType === "vertical"?"d-flex align-items-center justify-content-between":"d-flex flex-column"}`}>
                                    {
                                        this.props.layoutType === "vertical" ?  <h4 className="mb-0">{this.props.t(this.props.title)}</h4>:  <h6 className="mb-0">{this.props.t(this.props.title)}</h6>
                                    }
                                  

                                    <div className="page-title-right">
                                        <Breadcrumb listClassName="m-0">
                                            {
                                                this.props.breadcrumbItems.map((item, key) =>
                                                    key+1 === itemsLength ?
                                                        <BreadcrumbItem key={key} active><span style={{fontSize:this.props.layoutType==="horizontal"&&"13px"}}>{this.props.t(item.title)}</span></BreadcrumbItem>
                                                    :   <BreadcrumbItem key={key} ><Link to={item.link} style={{fontSize:this.props.layoutType==="horizontal"&&"13px"}}>{this.props.t(item.title)}</Link></BreadcrumbItem>
                                                )
                                            }
                                        </Breadcrumb>
                                    </div>

                                </div>
                            </Col>
                        </Row>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => ({
  layoutType: state.Layout.layoutType,
});


export default connect(mapStateToProps)(withNamespaces()(Breadcrumbs));